import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Alert, Paper } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/Layout';
import DataViewTable from '../../components/Dashboard/DataViewTable';
import DashboardAnalyticsService from '../../services/DashboardAnalyticsService';

const COLUMNS = [
  { field: 'request_type', headerName: 'Request Type', flex: 1.5, minWidth: 200 },
  { field: 'quarter', headerName: 'Quarter', flex: 0.7, minWidth: 80 },
  { field: 'approval_status', headerName: 'Approval Status', flex: 1, minWidth: 150 },
  { field: 'count', headerName: 'Count', flex: 0.6, minWidth: 70, type: 'number' },
];

const VolumeApprovalStatus = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchData = async () => {
    setLoading(true);
    setError('');
    try {
      const result = await DashboardAnalyticsService.getDataView({
        view_type: 'volume_approval_status',
      });
      const data = (result.data || []).map((row, idx) => ({ ...row, id: idx }));
      setRows(data);
      setTotal(result.total || data.length);
    } catch (err) {
      console.error(err);
      setError('Failed to load data. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleExport = (format) => {
    DashboardAnalyticsService.downloadExport(rows, 'volume-approval-status', format);
  };

  return (
    <Layout>
      <Box p={3}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate('/analytics-dashboard')}
          sx={{ mb: 2, textTransform: 'none', color: '#003781' }}
        >
          Back to Dashboard
        </Button>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
            {error}
          </Alert>
        )}

        <Paper elevation={2} sx={{ p: 3 }}>
          <DataViewTable
            title="Volume by Approval Status — Data View"
            columns={COLUMNS}
            rows={rows}
            loading={loading}
            total={total}
            page={0}
            pageSize={rows.length || 50}
            onExport={handleExport}
          />
        </Paper>
      </Box>
    </Layout>
  );
};

export default VolumeApprovalStatus;
